<template>
  <div id="app">
    <v-app>
      <Header />
      <AlertContainer />
      <router-view :key="$route.fullPath" />
    </v-app>
  </div>
</template>

<script>
import Header from './components/Header/Header.vue'
import AlertContainer from './components/AlertContainer.vue'

export default {
  name: 'App',
  components: {
    Header,
    AlertContainer,
  },
}
</script>

<style lang="stylus">
#app
  font-family 'Roboto', Helvetica, Arial, sans-serif
  -webkit-font-smoothing antialiased
  -moz-osx-font-smoothing grayscale
  text-align center
  color #524d48
  background-color white

#nav
  padding 30px
  a
    font-weight bold
    color #2c3e50
    &.router-link-exact-active
      color #42b983

.dataTables .v-table
  border 1px solid #ECF1C5

.dataTables .v-table tbody tr:nth-child(odd)
  background-color #ECF1C5
</style>
